import { useEffect, useState } from "react";
import { sortTermOptionsDesc } from "../utils/generalUtils";

export default function useAcademicTerms() {
  const [terms, setTerms] = useState([]);

  const fetchAcademicTerms = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/academic-term`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("api_token")}`,
          },
        },
      );
      const data = await res.json();
      setTerms(
        data.map((item) => ({
          label: item.label,
          value: item.label,
        })),
      );
    } catch (err) {
      console.error(`Error fetching academic terms:`, err);
    }
  };

  useEffect(() => {
    fetchAcademicTerms();
  }, []);

  return sortTermOptionsDesc(terms);
}
